export default __webpack_public_path__ + "d3211d3bcde2a215e05ed1a3061028e0.svg";